import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {catchError, Observable, of, tap } from 'rxjs';
import { environment } from '../../environments/environment';
import {NGXLogger} from 'ngx-logger';
import { Impresa } from '../models/impresa.model';
import { Centrale } from '../models/centrale.models';
import { RichiestaAggiornamentoCentrale } from '../models/richiestaAggiornamentoCentrale.models';
import { Listino } from '../models/listino.model';
import { ListinoNazionale } from '../models/listinoNazionale.model';


@Injectable({
  providedIn: 'root',
})
export class ListiniService{
  apiUrl: string = environment.apiUrl+"listino";

  constructor(
    private http: HttpClient,
    private logger: NGXLogger

    ) {}

  get(): Observable<any> {
    const headers = {
    };
    
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl, httpOptions);
  }

  getNazionale(): Observable<any> {
    const headers = {
    };
    
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"/nazionale", httpOptions);
  }

  getStoricoNazionale(): Observable<any> {
    const headers = {
    };
    
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"/nazionale/storico", httpOptions);
  }

  getById(id:String): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };
    
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"/"+id, httpOptions);
  }

  getStorico(id:String): Observable<any> {
    const headers = {
     // 'Authorization': `Bearer ${token}`,
    };
    
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.get(this.apiUrl+"/"+id+"/storico", httpOptions);
  }

  modifica(listino:Listino): Observable<any> {
    const headers = {
      //  'Authorization': `Bearer ${token}`,
      };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.put(this.apiUrl+"/"+listino.id, listino, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('modificaListino', []))
    );
  }
  modificaNazionale(listino:ListinoNazionale): Observable<any> {
    const headers = {
      //  'Authorization': `Bearer ${token}`,
      };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.put(this.apiUrl+"/nazionale/"+listino.id, listino, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('modificaListino', []))
    );
  }
  crea(listino:Listino): Observable<any> {
    const headers = {
      //  'Authorization': `Bearer ${token}`,
      };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.post(this.apiUrl, listino, httpOptions);
  }

  elimina(idListino:string): Observable<any> {
    //const token = localStorage.getItem("BEtoken");
    const headers = {
    //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.delete(this.apiUrl+"/"+idListino, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('eliminaListino', []))
    );
  }

  eliminaConfigurazione(idListino:string, regione:string): Observable<any> {
    //const token = localStorage.getItem("BEtoken");
    const headers = {
    //  'Authorization': `Bearer ${token}`,
    };
    const httpOptions = {
      headers,
      reportProgress: true,
    };
    return this.http.delete(this.apiUrl+"/"+idListino+"/"+regione, httpOptions).pipe(
      tap((res: any) => {
        return res;
      }),
      catchError(this.handleError<any[]>('eliminaListino', []))
    );
  }

  private handleError = <T>(operation = 'operation', result?: T) => {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      this.logger.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.logger.info(`${operation} failed: ${error.message}`);

      /*this.errorHandler.dialogConfig = {...this.dialogConfig};
      this.errorHandler.handleError(error);*/



      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  };

}